module.exports = __webpack_public_path__ + "static/media/login-logo.eab15249.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/login-logo.png
 ** module id = 356
 ** module chunks = 0
 **/